import React              from 'react';
import { useTranslation } from 'react-i18next';
import useStyles          from './tableToolbarStyles'

import Accordion          from '@mui/material/Accordion';
import AccordionDetails   from '@mui/material/AccordionDetails';
import AccordionSummary   from '@mui/material/AccordionSummary';
import DebouncedTextField from 'components/DebouncedTextField';
import ExpandMoreIcon     from '@mui/icons-material/ExpandMore';
import Grid               from '@mui/material/Grid';
import SelectField        from 'components/SelectField';
import Typography         from '@mui/material/Typography';

import { CARD_STATUSES_NS }   from 'i18n';
import { createSelectOption } from 'components/SelectField';
import { DATA_TABLE_NS }      from '../../const';
import PropTypes              from 'prop-types';

/**
 * A replacement for material-table toolbar which, passed as a
 * component, can not hold state which ruins transitions.
 */
export default function TableToolbar(props) {

  const { classes }  = useStyles();
  const { t }        = useTranslation(DATA_TABLE_NS, { keyPrefix: 'filters' });
  const cardStatuses = useTranslation(CARD_STATUSES_NS);

  const statusOptions = React.useMemo(() => {
    const result = [];
    result.push(createSelectOption('ACTIVE', cardStatuses.t('ACTIVE')));
    //TODO czekać aż zostanie ustalone czy status 'EXPIRED' dodać i czy 'ORDERED' zostanie taki czy zmieniony
    result.push(createSelectOption(
      'ORDERED',
      cardStatuses.t('ORDERED') + ' lub ' + cardStatuses.t('EXPIRED')
    ));
    result.push(createSelectOption('INACTIVE', cardStatuses.t('INACTIVE')));
    result.push(createSelectOption('RESTRICTED', cardStatuses.t('RESTRICTED')));
    result.push(createSelectOption('BLOCKED', cardStatuses.t('BLOCKED')));
    result.push(createSelectOption('CLOSED', cardStatuses.t('CLOSED')));
    return result;
  }, [cardStatuses]);

  return (
    <Accordion
      expanded={props.filtersExpanded}
      onChange={(_, expanded) => props.setFiltersExpanded(expanded)}
      className={classes.tableToolbar}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon/>}
        className={classes.accordionSummary}
      >
        <Typography className={classes.accordionSummaryTitle}>
          {t('accordionSummary')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.detailsContainer}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <DebouncedTextField
              value={props.cardIdFilterData}
              setValue={props.setCardIdFilterData}
              label={t('cardId')}
            />
          </Grid>
          {props.includeStatus &&
            <Grid item xs={6}>
              <SelectField
                includeEmptyOption
                value={props.statusFilterData}
                setValue={props.setStatusFilterData}
                label={t('status')}
                options={statusOptions}
              />
            </Grid>
          }
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

TableToolbar.propTypes = {
  filtersExpanded:    PropTypes.bool.isRequired,
  setFiltersExpanded: PropTypes.func.isRequired,

  cardIdFilterData:    PropTypes.string,
  setCardIdFilterData: PropTypes.func.isRequired,

  statusFilterData:    PropTypes.string,
  setStatusFilterData: PropTypes.func.isRequired,
};
